import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'


const data =[
  {
    id:1,
    title:"LMS",
    image:IMG1, 
    link:"https://github.com/Chathuraprabashwara/LMS",
    link2:""
  },

  {
    id:2,
    title:"Netflix Clone",
    image:IMG2, 
    link:"https://github.com/Chathuraprabashwara/Netflix-clone-ReactJS-TaliwindCSS",
    link2:""
  },
  {
    id:3,
    title:"Nullity of The Mind - Event Organizer Website",
    image:IMG3, 
    link:"",
    link2:"https://mind-void-edm-web.vercel.app/"
  },
  { id:4,
    title:"IdeaMad",
    image:IMG4, 
    link:"",
    link2:"https://ideamad.com/"
  },



]


const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>portfolio</h2>

    <div className="container portfolio__container">
  { data.map((data)=>  <article key={data.id} className='portfolio__item'>
      <div className="portfolio__item-image">
        <img src={data.image} alt="" style={{width: '100%', height: '250px'}} />
      </div>

        <h3>{data.title}</h3>
       <div className="portfolio__item-cta">
{     data.link &&   <a className='btn'  href={data.link} target="_blank" rel="noreferrer">Github</a>
}       {data.link2 && <a className='btn btn-primary'  href={data.link2} target="_blank" rel="noreferrer">Live Demo</a>}
       </div>
      
      </article>)}
    </div>

    </section>
  )
}

export default Portfolio